import { Api } from '@/shared/api';
import { LoginFormDTO, LoginFormResponseDTO } from '@/shared/api/dto';
import { Project } from '@/shared/config/projects';

/**
 * Отправка запроса на авторизацию
 */
export const login = async (
  project: Project,
  data: LoginFormDTO,
): Promise<LoginFormResponseDTO> => {
  const responseData = await Api.auth.login(project, data);

  return responseData;
};
